import { get } from "lodash";
import { useEffect, useMemo } from "react";

import {
  FilterFieldOption,
  FilterFieldOptionsHookResult,
} from "~/features/filter";
import { useGetLogsEmailNamesLazyQuery } from "~/schemas/generated/graphql";
import { stringListToSelectOption } from "~/shared/lib/StringListToSelectOption/stringListToSelectOption";

/**
 * Опции фильтра «Список логов»: названия email-рассылок.
 * value совпадает с label — в API уходит само название (параметр `name`).
 */
export const useEmailLogNameOptions = (): FilterFieldOptionsHookResult => {
  const [getEmailNames, { data, loading }] = useGetLogsEmailNamesLazyQuery({
    fetchPolicy: "cache-and-network",
  });

  useEffect(() => {
    getEmailNames();
  }, [getEmailNames]);

  const options = useMemo<FilterFieldOption[]>(
    () =>
      get(data, "LogGetter.getEmailNames", []).map(stringListToSelectOption),
    [data],
  );

  return { options, loading };
};
